import React from 'react'
import { type CrossClientQueryResultCellProps } from './types'
import { CrossClientContinueButton } from '../CrossClientContinueButton'

export const CrossClientQueryResultEvaluateCell: React.FC<CrossClientQueryResultCellProps> = ({ result }) => (
  <div className='zocks-py-0.75 flex-1 d-flex justify-content-end'>
    <CrossClientContinueButton result={result} />
  </div>
)
